/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `open` - Open
 * * `in_progress` - In Progress
 * * `resolved` - Resolved
 * * `false_positive` - False Positive
 * * `duplicate` - Duplicate
 * * `retest` - Retest
 * @export
 */
export const Status111Enum = {
    Open: 'open',
    InProgress: 'in_progress',
    Resolved: 'resolved',
    FalsePositive: 'false_positive',
    Duplicate: 'duplicate',
    Retest: 'retest'
} as const;
export type Status111Enum = typeof Status111Enum[keyof typeof Status111Enum];


export function instanceOfStatus111Enum(value: any): boolean {
    for (const key in Status111Enum) {
        if (Object.prototype.hasOwnProperty.call(Status111Enum, key)) {
            if (Status111Enum[key as keyof typeof Status111Enum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function Status111EnumFromJSON(json: any): Status111Enum {
    return Status111EnumFromJSONTyped(json, false);
}

export function Status111EnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): Status111Enum {
    return json as Status111Enum;
}

export function Status111EnumToJSON(value?: Status111Enum | null): any {
    return value as any;
}

export function Status111EnumToJSONTyped(value: any, ignoreDiscriminator: boolean): Status111Enum {
    return value as Status111Enum;
}

